export default __webpack_public_path__ + "static/media/household-1.e2b205ca.jpg";